import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { InputHTMLAttributes, useId, useState } from 'react';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  wrapperClassName?: string;
};

export function PasswordInput({
  className = '',
  wrapperClassName = '',
  id,
  disabled,
  ...props
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false);
  const fallbackId = useId();
  const inputId = id ?? fallbackId;

  return (
    <div className={`relative ${wrapperClassName}`.trim()}>
      <input
        {...props}
        id={inputId}
        type={visible ? 'text' : 'password'}
        disabled={disabled}
        className={`${className} pr-11`.trim()}
      />
      <button
        type="button"
        className="absolute inset-y-0 right-0 flex items-center rounded-r-lg px-3 text-secondary-500 transition-colors hover:text-secondary-700 disabled:cursor-not-allowed disabled:opacity-50"
        onClick={() => setVisible((current) => !current)}
        aria-label={visible ? 'Ocultar senha' : 'Mostrar senha'}
        aria-pressed={visible}
        disabled={disabled}
        tabIndex={-1}
      >
        {visible ? <EyeSlashIcon className="h-5 w-5" aria-hidden="true" /> : <EyeIcon className="h-5 w-5" aria-hidden="true" />}
      </button>
    </div>
  );
}
